
const Portuguese = {
    "form.isRequired": "{name} é requerido",
    "form.OTPLabel": "Código de verificação de e-mail",
    "form.OTPInputValidMessage": "Certa",
    "form.OTPInputInvalidMessage": "OTP errada",
    "form.OTPWaitSecondsLabel": "Enviar novamente ({waitOtpSeconds}s)",
    "form.OTPSendLabel": "Enviar OTP",
    "form.OTPSendSuccessLabel": "Envio do código de verificação para seu e-mail com sucesso",
    "form.OTPTips": "Insira OTP válida",
    "form.selectInputLabel": "Procurar…",
    "form.uploadBtn": "FAZER UPLOAD",
    "form.uploadSizeTips": "Os arquivos devem ter menos de 5 MB.",
    "form.uploadTypeTips": "Tipos de arquivo permitidos: png gif jpg jpeg pdf.",
    "form.uploadNumTips": "É necessário fazer upload de um arquivo.",
    "form.isRequiredAccept": "Você deve aceitar para prosseguir.",
    "form.sendButton": "ENVIAR",
    "form.isEmail": "Inserir uma conta de e-mail válida",
    "form.isSerialNumber": "Inserir 13 caracteres em {name}.",
    "form.categoryPlaceholder": "Selecionar a categoria do produto",
    "form.seriesPlaceholder": "Selecionar a série do produto",
    "form.skuPlaceholder": "Número do modelo (SKU)",
    "form.sendSuccessMsg": "Envio bem-sucedido",

    "warrantyPeriod.checkTitle": "Check Warranty Period",
    "warrantyPeriod.checkDescription": "Please enter your email and serial number to check the warranty period.",
    "warrantyPeriod.emailLabel": "Email",
    "warrantyPeriod.emailPlaceholder": "Enter Email",
    "warrantyPeriod.serialNumberLabel": "Serial Number",
    "warrantyPeriod.serialNumberPlaceholder": "Enter Serial Number",
    "warrantyPeriod.checkButton": "Check",
    "warrantyPeriod.sendSuccessfulLabel": "Send Successfully! please check your email",
    "warrantyPeriod.checkNoRecordLabel": "Sorry, no record was found!",
}
export {
    Portuguese
}   